import { X } from 'lucide-react'

interface TranscriptionConsentBannerProps {
  show: boolean
  onDismiss: () => void
}

export function TranscriptionConsentBanner({
  show,
  onDismiss,
}: TranscriptionConsentBannerProps) {
  return (
    <div
      className={`
        absolute top-4 w-full left-1/2 -translate-x-1/2 z-50
        bg-vc-surface text-vc-text px-4 py-3 rounded-lg shadow-xl
        flex items-center gap-4 max-w-4xl border border-stroke-100/20
        transition-all duration-500 ease-in-out
        ${show
          ? 'opacity-100 translate-y-0 scale-100'
          : 'opacity-0 -translate-y-4 scale-95 pointer-events-none'
        }
      `}
    >
      <span className="sm:text-xs flex-1">
        <span className="hidden sm:inline text-[14px]">
          Transcription service is now active. By continuing, you consent to transcription and storage of your audio during the meeting.
        </span>
        <span className="sm:hidden text-xs">Transcription active. Audio will be transcribed.</span>
      </span>
      <button
        type="button"
        onClick={onDismiss}
        className="cursor-pointer text-white/60 hover:text-white hover:bg-card/10 rounded-full p-1 transition-all duration-200"
      >
        <X className="h-5 w-5" />
      </button>
    </div>
  )
}
